import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StrongPasswordValidatorDirective } from './strong-password.directive';
import { MatchPasswordValidatorDirective } from './match-password.directive';
import { StrengthMeterComponent } from '../strength-meter/strength-meter.component';
import { PasswordFeedbackComponent } from '../password-feedback/password-feedback.component';
import { PasswordScoreComponent } from '../password-score/password-score.component';
import { PasswordMatchComponent } from '../password-match/password-match.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    StrongPasswordValidatorDirective,
    MatchPasswordValidatorDirective,
    StrengthMeterComponent,
    PasswordFeedbackComponent,
    PasswordScoreComponent,
    PasswordMatchComponent,
  ],
  exports: [
    StrongPasswordValidatorDirective,
    MatchPasswordValidatorDirective,
    StrengthMeterComponent,
    PasswordFeedbackComponent,
    PasswordScoreComponent,
    PasswordMatchComponent,
  ],
})
export class StrongPasswordModule {}
